export const buttonTitle = [
  {
    name: 'HIRE A DEVELOPER',
    logo: S,
    navigate: '/hire-a-developer',
  },
];

import S from '../../assets/FooterLogo/S.png';
